import React from 'react';
import Module from 'Components/Core/Module';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import 'CSS/Member/Member.css';
import './ForumOptions.css';

export default function ForumOptions(props) {

	const x = props.x;
	const wafId = props.id;

	x.waf.init(wafId, {
		"onAfterRead": onAfterRead
	});

	x.wam.init(props.id, {
		"onClose": () => {
			x.waf.destroy(wafId);
		}
	});

	function onAfterRead(data) {
		x.waf.set(wafId, 'title', data.content.title, true);
		x.waf.set(wafId, 'registrationcode', data.content.registrationcode, true);
		x.waf.set(wafId, 'develop', data.content.develop, true);
		x.waf.set(wafId, 'answerasquote', data.content.answerasquote, true);
		x.waf.set(wafId, 'chatmode', data.content.chatmode, true);
		x.waf.set(wafId, 'twofactorauth', data.content.twofactorauth, true);
		x.waf.set(wafId, 'adminforum', data.content.adminforum, true);
		x.waf.set(wafId, 'pagestore', data.content.pagestore, true);
		x.waf.set(wafId, 'banking', data.content.banking, true);
		x.waf.set(wafId, 'rezepte', data.content.rezepte, true);
		x.waf.set(wafId, 'marketdata', data.content.marketdata, true);
	}

	function generateRegistrationCode() {
		x.waf.set(wafId, 'registrationcode', crypto.randomUUID());
	}

	function rebuildPostingIndex() {
		x.was.axPost('Backend/webapp.php?module=System&task=RebuildPostingIndex', {}, (result) => {
			if (result.data.returncode === 1) {
				x.wah.addHint('Suchindex-Rebuild gestartet. Das läuft im Hintergrund und kann je nach Anzahl der Beiträge mehrere Minuten dauern.');
			}
			else {
				x.wah.addHint('Suchindex-Rebuild konnte nicht gestartet werden!', true);
			}
		});
	}

	return (
		<Module id={props.id} x={x} title={props.title} display={props.display} displayTitle="d-block" closeButton="1">
			<div className="instance-options settings">
				<Form x={x}
					wafId={wafId}
					module="System"
					readTask="GetProjectSettings"
					sendTask="SaveProjectSettings"
					focusElement="title"
					classes="member-form instance-options-form"
				>
					<div className="settings-card">
						<h3 className="settings-card-title">Allgemein</h3>
						<FormElement x={x} wafId={wafId} id="title" title="Titel" mandatory={true} />
						<FormElement x={x} wafId={wafId} id="registrationcode" title="Registrierungs-Code" mandatory={true} classes="reg-code-input">
							<button type="button" className="btn btn-sm" onClick={generateRegistrationCode}>
								<i className="bi bi-arrow-clockwise"></i>Neu erzeugen
							</button>
						</FormElement>
						<FormElement type="checkbox" x={x} wafId={wafId} id="develop" title="Develop-Modus" />
					</div>

					<div className="settings-card">
						<h3 className="settings-card-title">Forum</h3>
						<FormElement type="checkbox" x={x} wafId={wafId} id="answerasquote" title="Antworten als Zitat in neuem Thread" />
						<FormElement type="checkbox" x={x} wafId={wafId} id="chatmode" title="Chat-Modus (Standard für Mitglieder ohne eigene Einstellung)" />
						<FormElement type="checkbox" x={x} wafId={wafId} id="adminforum" title="Admin-Forum bereitstellen" />
					</div>

					<div className="settings-card">
						<h3 className="settings-card-title">Optionale Module</h3>
						<FormElement type="checkbox" x={x} wafId={wafId} id="pagestore" title="Page Store bereitstellen" />
						<FormElement type="checkbox" x={x} wafId={wafId} id="banking" title="Banking bereitstellen" />
						<FormElement type="checkbox" x={x} wafId={wafId} id="rezepte" title="Rezepte bereitstellen" />
						<FormElement type="checkbox" x={x} wafId={wafId} id="marketdata" title="Kursdaten bereitstellen" />
					</div>

					<div className="settings-card">
						<h3 className="settings-card-title">Sicherheit</h3>
						<FormElement type="checkbox" x={x} wafId={wafId} id="twofactorauth" title="Zwei-Faktor-Authentifizierung (E-Mail) für alle Logins erzwingen" />
					</div>
				</Form>

				<div className="settings-card">
					<h3 className="settings-card-title">Wartung</h3>
					<p className="settings-card-hint">Baut den Redis-Suchindex aller Beiträge komplett neu auf. Läuft im Hintergrund, bei vielen Beiträgen kann das mehrere Minuten dauern.</p>
					<button type="button" className="btn" onClick={rebuildPostingIndex}>Suchindex neu aufbauen</button>
				</div>
			</div>
		</Module>
	)

};
